export default [
    {
        path: '/backoffice-scrumboard',
        component: () => import('@/views/BackofficeScrumboard'),
        props: true,
    },
];
